import { createFileRoute } from "@tanstack/react-router";

// Página ainda sem conteúdo. Criada para que os links do cabeçalho e do rodapé funcionem.
export const Route = createFileRoute("/politica-de-privacidade")({
  component: Page,
});

function Page() {
  return <main className="min-h-screen bg-background-white" />;
}
